module.exports = __webpack_public_path__ + "static/media/logos.2333e8d6.svg";